import React from "react";

// Material imports
import Comment from "@limitless/icons/Comment";

// Limitless imports
import Badge from "@limitless/modern/feedback/badge/Badge";
import { useExpertTaskListContext } from "@limitless/expert";

const TaskBadgeIcon = () => {
    const {
        tasklist: { unreadStickyCount }
    } = useExpertTaskListContext();

    return (
        <Badge
            content={<Comment />}
            count={unreadStickyCount}
            name="tasks"
            sx={{ "& .MuiBadge-badge": { top: 27, left: 35 } }}
        />
    );
};

export default TaskBadgeIcon;
